import { http } from '../../../api'

const taskComposeText = {
  namespaced: true,
  state: {
    task: null
  },
  actions: {
    createComposeTask: ({ commit }, params) => {
      return http.post('/task-compose-text', params).then(res => {
        return res.data
      })
    },
    getTask: ({ commit }, params) => {
      return http.get('/task-compose-text/' + params).then(res => {
        console.log('res', res)
        commit('setTask', res.data)
      })
    },
    updateComposeTask: ({ commit }, params) => {
      return http.post('/task-compose-text/' + params.id, params.data).then(res => {
      })
    }
  },
  mutations: {
    setTask (state, data) {
      state.task = data
    }
  },
  getters: {
    task: state => state.task
  }
}

export default taskComposeText
